import { Component, ChangeDetectionStrategy, ViewEncapsulation, output, input } from '@angular/core';
import { FiDialogsContentBase } from '@fi-app/shared/fi-dialogs/fi-dialogs-content-base';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiDialogCloseReason } from '@fi-app/shared/fi-dialogs/fi-dialogs-close-reason';

export interface IAvailableReportWidget extends INameIdObj {
    IconClassName: string;
}

export interface IAvailableReportWidgetDialogData {
    availableReportWidgetsData: IAvailableReportWidget[];
    preventExtraPadding?: boolean;
}

@Component({
    selector: 'fi-report-widget-new-widget-type-select-step',
    templateUrl: './new-widget-type-select-step.component.html',
    styleUrls: ['./new-widget-type-select-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-report-widget-new-widget-type-select-step' },
    standalone: false,
})
export class FiReportWidgetNewWidgetTypeSelectStepComponent extends FiDialogsContentBase<
    IAvailableReportWidgetDialogData,
    number
> {
    protected setCurrentReportWidgetType(reportWidgetType: number): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.YesButton,
            value: reportWidgetType,
        });
    }

    protected onCloseDialog(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.NoButton,
        });
    }
}
